module.exports = __webpack_public_path__ + "img/fire.009fb757.png";